import { IGif } from '@giphy/js-types';

import { useUserContext } from 'hooks/useUserContext';

import useGiphy from 'utils/giphy/useGiphy';
import { trackCTATapped } from 'utils/segment/trackingEvents';

type UseLandingBaseApi = {
  onFAQClick: () => void;
  gif: IGif | null;
};

const useLandingBase = (pageLocation: string): UseLandingBaseApi => {
  const [userData] = useUserContext();
  const { memoGifId, publicId } = userData;
  const { gif, error: giphyError } = useGiphy(memoGifId);

  const onFAQClick = () => {
    trackFAQClick(publicId, pageLocation);
  };

  return {
    onFAQClick,
    gif: giphyError ? null : gif,
  };
};

const trackFAQClick = (publicId, pageLocation) =>
  trackCTATapped(
    'Pay Anyone',
    'Instant Transfer FAQs',
    pageLocation,
    'instant_transfer_faqs_cta',
    publicId
  );

export default useLandingBase;
